// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3S2BZ","description":"PatientConsentPreview_description__2tzh2"};